import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { PenDimensionDto, UpdatePenDimension } from 'models/pen/PenDimension';

@autoinject
export class PenDimensionService {
  constructor(private client: NetlogHttpClient) {}

  async getPenDimension(id: number) {
    return await this.client.get<PenDimensionDto>({
      url: `api/pen-dimension/${id}`,
      model: PenDimensionDto,
    });
  }

  async updatePenDimension(id: number, data: UpdatePenDimension) {
    return await this.client.post({
      data,
      url: `api/pen-dimension/${id}`,
    });
  }

  async updatePenDimensionPipeCount(id: number, pipeCount) {
    return await this.client.post({
      url: `api/pen-dimension/${id}/pipeCount/${pipeCount}`,
    });
  }

  async createDeleteBottomRing(id: number) {
    return await this.client.post({
      url: `api/pen-dimension/${id}/bottom-ring`,
    });
  }
}
